const FIELD_VALIDATION_CAPTIONS = {
  Mandatory: 'is mandatory field',
  'Invalid Value': 'invalid value',
  'Valid Indicator': 'Good',
}

export default FIELD_VALIDATION_CAPTIONS

export const FIELD_VALIDATION_CAPTIONS_ENUM = {
  MANDATORY: FIELD_VALIDATION_CAPTIONS['Mandatory'],
  INVALID_VALUE: FIELD_VALIDATION_CAPTIONS['Invalid Value'],
  VALID_INDICATOR: FIELD_VALIDATION_CAPTIONS['Valid Indicator'],
}
